import { PlanType } from '@labrav/react-components'
import type { OffersWithErrors } from '../privateOfferCreation/types'
import { OfferStatus, type PrivateOffer } from '../types'

export const getOfferForCloneOffer = ({
  privateOffer,
  productType,
}: {
  privateOffer: PrivateOffer
  productType?: PlanType
}) => {
  const {
    privateOfferName,
    flexiblePaymentTerms,
    awsProductId,
    companyName,
    crmOrderObjectId,
    crmOpportunityId,
    awsServiceStartDate,
    awsAccountId,
    serviceLength,
    entitlementOption,
    eulaType,
    eulaFile,
    renewal,
    renewalChannel,
    autoRenew,
    zeroDollarPricing,
    offerRecipients,
    installments,
    firstInstallmentDate,
    flexiblePaymentType,
    tcv,
    subscriptionEndDate,
    emailCustomMessage,
    metaData,
    dimensions,
    variableStartDate,
    offerStakeholders,
    customOfferStakeholders,
    agreementStartDate,
    agreementEndDate,
  } = privateOffer

  const offerRecipientsData = (offerRecipients || [])?.map(
    offerRecipientItem => ({
      firstName: offerRecipientItem?.firstName,
      lastName: offerRecipientItem?.lastName,
      email: offerRecipientItem?.email,
      title: offerRecipientItem?.title,
      crmObjectId: offerRecipientItem?.crmObjectId,
    })
  )
  const metaDataDetail = (metaData || [])?.map(metaDataItem => ({
    key: metaDataItem?.key,
    value: metaDataItem?.value,
    crmObjectId: metaDataItem?.crmObjectId,
  }))
  const installmentsData = (installments || [])?.map(installmentItem => ({
    amount: installmentItem?.amount,
    paymentDate: '',
    currency: installmentItem?.currency,
  }))

  return {
    privateOfferName: `Clone ${privateOfferName}`,
    flexiblePaymentTerms,
    companyName,
    crmOrderObjectId: crmOrderObjectId || '',
    crmOpportunityId,
    awsServiceStartDate,
    awsAccountId,
    serviceLength,
    eulaType,
    eulaFile,
    firstInstallmentDate,
    tcv,
    renewal,
    renewalChannel,
    autoRenew,
    offerExpirationDate: '',
    agreementStartDate: agreementStartDate || '',
    zeroDollarPricing,
    offerRecipients: offerRecipientsData,
    installments: installmentsData,
    flexiblePaymentType,
    emailCustomMessage,
    metaData: metaDataDetail,
    dimensions: (dimensions || [])?.map(dimensionItem => ({
      ...dimensionItem,
      awsProductId,
    })),
    variableStartDate,
    offerStakeholders,
    customOfferStakeholders,
    awsProductId,
    draft: true,
    offerStatus: OfferStatus.PRIVATE_OFFER_CREATION_IN_PROGRESS,
    ...(productType === PlanType.SAAS_CONTRACT
      ? {
          entitlementOption,
          subscriptionEndDate: subscriptionEndDate || agreementEndDate || '',
          agreementEndDate: agreementEndDate ?? subscriptionEndDate ?? null,
        }
      : {}),
    ...(productType === PlanType.SAAS_SUBSCRIPTION
      ? {
          subscriptionEndDate,
        }
      : {}),
  } as OffersWithErrors
}
